<template>
    <v-card class="my-2">
        <v-card-title>Store "villa_for_you"</v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ remark }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="CreateStore()" v-if="remark === ''">Create Store</v-btn>
            <v-btn color="primary" small @click="CreateStore()" v-else>Update Store</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                store: {},
                remark: "",
            }
        },
        mounted () {
            this.getVectorStores();
        },
        methods: {
            getVectorStores() {
                this.store = {};
                this.remark = "Updating Store Info."
                this.$axios.post("ares/json/ares/syst/openai/getVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getVectorStores"
                    },
                    getVectorStores: {
                        refresh: false,
                    },
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                    } else {
                        let newRemak = "Store not found."
                        for (let i=0; i<res.data.getVectorStores.length; i++) {
                            if (res.data.getVectorStores[i].name === "villa_for_you") {
                                this.store = res.data.getVectorStores[i];
                                newRemak = "";
                            }
                        }
                        this.remark = newRemak;
                    }
                });
            },
            CreateStore() {
                this.remark = "Updating Store ...";
                this.$axios.post("ares/json/ares/syst/openai/createVectorStoreVFY.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "createVectorStoreVFY"
                    },
                    createVectorStoreVFY: {
                    },
                }).then(res => {
                    this.getVectorStores();
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.getVectorStores();
                    } else {
                        this.getVectorStores();
                    }
                });
            },
        }
    }
</script>